import { KirbyQuerySchema } from "./kql"

export interface KirbyImageData {
  id: string
  mime: string
  uuid: string
  filename: string
  url: string
  src: string
  srcset: string
  thumb: string
  width: number
  height: number
  ratio: number
  alt: string
  caption: string
  focus: string //JSON string
}

export const imageQuery: KirbyQuerySchema["select"] = {
  id: true,
  mime: "file.mime",
  uuid: "file.uuid",
  filename: "file.filename",
  url: "file.url",
  src: "file.resize(1024).url",
  srcset: "file.srcset([480, 1280, 2048, 4096])",
  thumb: "file.resize(32, 32, 60).url",
  width: "file.width",
  height: "file.height",
  ratio: "file.ratio",
  caption: "file.caption.kt",
  alt: "file.alt",
  focus: "file.focus",
}
